import styled from 'styled-components';
import { Modal, ModalHeader } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledModal = styled(Modal)`
  max-width: 1112px;
  height: 833px;
  top: 4%;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  width: 100%;
  left: 0;
  top: 104px;
  flex-wrap: wrap;
  order: 3;
  margin: 0 10px;
  max-height: 50vh;
  overflow-y: hidden;

  &:hover {
    overflow-y: scroll;

    > section {
      width: 100%;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none !important;
      background-color: transparent !important;
    }

    &::-webkit-scrollbar {
      width: 6px !important;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #acacac;
    }
  }
`;

export const StyledUploadButton = styled(Button)`
  box-sizing: border-box;
  margin-left: 16px;
`;

export const StyledCloseButton = styled(Button)`
  box-sizing: border-box;
  margin-left: 16px;

  &:hover,
  &:active {
    color: #000000 !important;
    background-color: #ffffff !important;
  }
  &:focus {
    background-color: #ffffff;
    box-shadow: 0 0 0 0.0625rem #0095ff;
  }
`;

export const StyledJustifyRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledModalHeader = styled(ModalHeader)`
  .modal-title {
    width: 100%;
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  h5 {
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    color: #33373d;
  }

  p {
    font-weight: lighter;
    font-size: 16px;
    margin-bottom: 0;
    color: #6e7582;
  }

  padding-bottom: 0;
  border-bottom: none;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`;
